import { LIVE_HOSTNAME, isLiveSite } from "./liveSite";

/**
 * Only the live home page belongs in search results.
 *
 * Every other page this app serves gets a `noindex`: the AR routes the sign QR
 * codes open (/seahorse, /crab, ...), the /dev pages, and the go.eyejack.dev /
 * go.eyejack.io copies of the whole site. The home page gets a canonical link
 * instead. The same index.html is served for every route, so this has to be
 * decided at runtime; search engines render the page before indexing it. On
 * the live site the CDN also sends a matching `X-Robots-Tag` header for
 * crawlers that don't run JavaScript (see sst.config.ts). robots.txt
 * deliberately blocks nothing, or crawlers could not see the noindex.
 *
 * Must run before `captureArtworkFromUrl`, which moves the sign out of the URL.
 */
export function applySearchIndexing(): void {
  if (isLiveSite() && window.location.pathname === "/") {
    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = `https://${LIVE_HOSTNAME}/`;
    document.head.appendChild(canonical);
  } else {
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex";
    document.head.appendChild(robots);
  }
}
